import { ReactElement } from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleExclamation,
  faCircleQuestion,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';

import { InlineNotificationProps } from './types';

export function InlineNotification({
  type,
  children,
}: InlineNotificationProps): ReactElement {
  let bgColor = 'bg-skys-the-limit';
  let icon = faCircleQuestion;

  if (type === 'warning') {
    icon = faTriangleExclamation;
    bgColor = 'bg-lemon';
  } else if (type === 'error') {
    icon = faCircleExclamation;
    bgColor = 'bg-brick opacity-10';
  }

  const bgClass = clsx('absolute top-0 left-0 -z-1 h-full w-full', bgColor);

  return (
    <div className="relative flex w-full items-center p-4 ">
      <FontAwesomeIcon icon={icon} className="mr-4 text-2xl" />
      {children}
      <div className={bgClass} />
    </div>
  );
}
